"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignIssueActionPicker = void 0;
const DataType_1 = __importDefault(require("@opsbase/lib-datatype/DataType/DataType"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const WorkflowAction_1 = __importDefault(require("@opsbase/lib-workflow/WorkflowAction"));
const DataChooser_1 = __importDefault(require("@opsbase/web-data-choosers/DataChooser"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane/Pane"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
function AssignIssueActionPicker(props) {
    var _a;
    const { action, onChangeAction, disabled = false } = props;
    const config = action === null || action === void 0 ? void 0 : action.workflowActionConfig;
    const handleChangeAssignee = (0, react_1.useCallback)(a => {
        if (a.length) {
            config.assignTo.id = a[0].id;
            config.assignTo.title = a[0].title;
            config.assignTo.type = a[0].type;
            action.workflowActionConfig = config;
            onChangeAction(new WorkflowAction_1.default(action));
        }
    }, [config, action, onChangeAction]);
    return (react_1.default.createElement(Horizontal_1.default, { centered: true, gutter: true, justify: 'flex-start' },
        react_1.default.createElement(Text_1.default, null, lib_i18n_1.default.t('assignto')),
        react_1.default.createElement(Pane_1.default, { style: { width: 200 } },
            react_1.default.createElement(DataChooser_1.default, { disabled: disabled, value: ((_a = config === null || config === void 0 ? void 0 : config.assignTo) === null || _a === void 0 ? void 0 : _a.id)
                    ? [
                        {
                            id: config === null || config === void 0 ? void 0 : config.assignTo.id,
                            title: config === null || config === void 0 ? void 0 : config.assignTo.title,
                            type: config === null || config === void 0 ? void 0 : config.assignTo.type,
                        },
                    ]
                    : [], type: [DataType_1.default.STAFF, DataType_1.default.POSITION, DataType_1.default.TEAM], onChange: handleChangeAssignee }))));
}
exports.AssignIssueActionPicker = AssignIssueActionPicker;
exports.default = AssignIssueActionPicker;
